<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="element !== null">
    <div class="p-grid">
      <div class="p-col-6">
          <h2>{{ t('common.labels.basedata') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
        <button withRight="admin.element.edit" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'name'" [control]="form.get('name')" [type]="'input'" [label]="t('common.labels.name')" [edit]="inEdit" [basevalue]="element.name"></app-form-control>
        <app-form-control [cid]="'title'" [control]="form.get('title')" [type]="'input'" [label]="t('common.labels.title_on_ac')" [edit]="inEdit" [basevalue]="element.title"></app-form-control>
      </div>
      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'type'" [control]="form.get('type')" [type]="'select'" [options]="types" [label]="t('common.labels.type')" [edit]="inEdit" [basevalue]="t(element.getTypename())"></app-form-control>
      </div>
    </div>

  </form>

  <app-inherit-dialog
    [title]="t('common.labels.save')"
    [mode]="'exercise'"
    [(visible)]="inheritVisible"
    (okClicked)="saveBasedata($event)"
  ></app-inherit-dialog>

</ng-container>
